/* eslint-disable @atlaskit/editor/no-re-export */
// Entry file in package.json

export const searchMatchClass = 'search-match';
export const searchMatchTextClass = 'search-match-text';
export const selectedSearchMatchClass = 'selected-search-match';

export const blockSearchMatchClass = 'search-match-block';
export const selectedBlockSearchMatchClass = 'search-match-block-selected';

export const darkModeSearchMatchClass = 'search-match-dark';
export const searchMatchExpandTitleClass = 'search-match-expand-title';
